import { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleTextInput from '../../components/ModuleTextInput';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';
import { useContext } from 'react';
import { CampaignContext } from '../../../../../../../contexts/CampaignContext';

const ReadOnlyField = (props) => {
    const fieldData = props.fieldData;
    const customisationVars = props.customisationVars;

    // const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    let fieldDataSchema = null;
    if (fieldData?.customFieldConfig?.dataLink) {
        fieldDataSchema = getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.path, fieldData.customFieldConfig.dataLink);
        console.log("ReadOnlyField: Fetched field data schema:", fieldDataSchema);
    }
    const isDropdown = fieldDataSchema?.type === 'dropdown';
    const isMultiline = fieldDataSchema?.type === 'textarea';

    let displayValue = getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
    if (isDropdown && fieldDataSchema?.valOptions) {
        const option = fieldDataSchema.valOptions.find(opt => (opt.value === displayValue || opt.val === displayValue));
        displayValue = option ? option.label : displayValue;
    }
    if (!displayValue || (typeof displayValue === 'string' && displayValue.trim() === '')) {
        displayValue = '<No Value>';
    }

    const noFieldToDisplayStyle = {};
    if (!fieldData?.customFieldConfig?.dataLink) {
        noFieldToDisplayStyle.marginBottom = '0.25rem';
        noFieldToDisplayStyle.marginTop = '0.25rem';
    }

    if (fieldData?.customFieldConfig?.customFieldLabel === '-' && !fieldData?.customFieldConfig?.dataLink) {
        return <hr />;
    }

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled && fieldData?.customFieldConfig?.dataLink ? ' disabled' : ''}`} style={noFieldToDisplayStyle}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Read Only'}</div>
            {fieldData?.customFieldConfig?.dataLink &&
                <ModuleTextInput
                    value={displayValue}
                    fieldId={'read-only-field'}
                    enabled={true}
                    editable={false}
                    readonly={true}
                    multiline={isMultiline}
                    onChange={
                        (fieldId, value) => {
                        /*  WORKING_ON_NODE_DATA.fieldData = fieldData;
                            WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
                            updateCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                            props?.forceUpdateComponent?.(); */
                        }
                    }
                />
            }
        </>
    );
};

export default ReadOnlyField;
